import { useIntl } from 'react-intl';

import messages from '@/components/emotion-detector/messages';

import { EMPTY_STATE_ICON } from '../constants';
import { EmptyState, EmptyStateIcon, EmptyStateText } from '../styles';

export default function EmptyStateComponent() {
	const { formatMessage } = useIntl();

	return (
		<EmptyState>
			<EmptyStateIcon>{EMPTY_STATE_ICON}</EmptyStateIcon>
			<EmptyStateText>{formatMessage(messages.cameraRecommendationsEmpty)}</EmptyStateText>
		</EmptyState>
	);
}
